export default function List({
  title,
  service,
  children,
}: {
  title: string;
  service: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <section className="usage">
      <div className="usage__container container">
        <h3 className={service !== "resizer" ? "center" : ""}>{title}</h3>
        <ul className="usage__list">{children}</ul>
      </div>
    </section>
  );
}
